<template>
  <div class="rt-query">
    <el-input
      :value="value"
      v-bind="$attrs"
      :placeholder="placeholder"
      @keyup.enter.native="enterHander"
      @input="inputHander"
    >
      <rt-icon
        slot="suffix"
        :size="28"
        class="rt-query-icon"
        color="#fff"
        name="rt-base-lookup"
        @click.native="onSearch"
      />
    </el-input>
  </div>
</template>

<script>
import RtIcon from '../icon/rtIcon';
export default {
  name: 'RtQuery',
  components: {
    RtIcon
  },
  props: {
    value: [String, Number],
    placeholder: {
      type: String,
      default() {
        return this.$tx('搜索', 'xpc.search.search');
      }
    }
  },
  methods: {
    enterHander() {
      this.onSearch();
    },
    inputHander(value) {
      this.$emit('input', value);
    },
    onSearch() {
      this.$emit('on-search', this.value);
    }
  }
};
</script>



// WEBPACK FOOTER //
// rtQuery.vue?4b09c1de